var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbutton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.001,
    viewBox: "0 0 27 27.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(-1649.66 -963.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(721.66)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42836",
    "data-name": "Path 42836",
    d: "M21.368.929H5.632A5.652,5.652,0,0,0,0,6.588V22.271A5.652,5.652,0,0,0,5.632,27.93H21.368A5.652,5.652,0,0,0,27,22.271V6.588A5.652,5.652,0,0,0,21.368.929Zm3.569,21.342a3.581,3.581,0,0,1-3.569,3.586H5.632a3.581,3.581,0,0,1-3.569-3.586V6.588A3.581,3.581,0,0,1,5.632,3H21.368a3.581,3.581,0,0,1,3.569,3.586Z",
    transform: "translate(928 962.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42841",
    "data-name": "Path 42841",
    d: "M157.862,113.727h-7.24a1.042,1.042,0,1,0,0,2.084H153.2v8.346a1.042,1.042,0,1,0,2.084,0v-8.346h2.578a1.042,1.042,0,1,0,0-2.084Z",
    transform: "translate(787.419 856.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8401",
    "data-name": "Rectangle 8401",
    width: 17,
    height: 1,
    rx: 0.5,
    transform: "translate(933 984)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbutton);
export default __webpack_public_path__ + "static/media/Tbutton.3590bfa78c325c7a6f0b43ad943f9a4c.svg";
export { ForwardRef as ReactComponent };